module.exports = __webpack_public_path__ + "static/media/close-red.ec6aa083.svg";